"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const ButtonBase_1 = require("./ButtonBase");
exports.Button = styled_1.default(ButtonBase_1.ButtonBase) `
  background-color: ${styled_tools_1.prop('theme.accent')};
  border: none;
  border-radius: 24px;
  color: ${styled_tools_1.prop('theme.gray5')};
  padding-bottom: 12px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 12px;
  text-align: center;
  text-transform: none;
  font-size: 0.875rem;
  line-height: 1em;
  transition: 0.3s;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  white-space: nowrap;

  &:hover {
    background-color: ${styled_tools_1.prop('theme.primaryLight')};
  }

  &:active {
    background-color: ${styled_tools_1.prop('theme.primaryLight')};
    outline: none;
  }

  &:focus {
    background-color: ${styled_tools_1.prop('theme.primaryLight')};
    outline: none;
  }
`;
exports.Button.defaultProps = {
    opaque: true,
    palette: 'primary',
};

//# sourceMappingURL=Button.js.map
